import { Component } from "react";
import "../../../../styles/css/searchspace.scss";
import "../../../../App.css";
import apis from "../../../../Providers.Api/apis";
import Spinner from "../../../../Components/Navigation/LoadingSpinner/Spinner";
import { withRouter } from "react-router-dom";
import History from "history";
import { RouterProps } from "react-router-dom";
import { IPartialAppState, appContext } from "../../../../AppContext";
import SpaceAnalyticsCard, { Props as SpaceCardProps } from "../../../../Components/Cards/SpaceAnalyticsCard/SpaceAnalyticsCard";
import IbssbreadcrumbLeft from '../../../../Components/Navigation/Breadcrumbs/IbssbreadcrumbLeft';
import { UPDATE_MAIN_PAGE_TITLE, ONELENS_SPACEANALYTICS_OVERVIEW } from "../../../../app/constants";
import SpaceAnalyticsMainSearch from "./SpaceAnalyticsMainSearch";
import Alert from "../../../../Components/Miscellaneous/Alert/Alert";
import { Box, Grid } from "@mui/material";
import IbssButtonRedo from "../../../../Components/Buttons/Button/IbssButton";
import { DateTime } from "luxon";
import { Space } from "../../../../Providers.Api/Spaces/SpaceRepository";
import { DateHelper } from "../../../../Common/DateHelper";
import { getBuildingNameUsingBuildingId, periodType } from "../../../../Common/Helper";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import { QueryParams } from "./QueryParams";
import { StringHelper } from "../../../../Common/StringHelper";
import IbssPageHeader from "../../../../Components/Headings/PageHeading/IbssPageHeader";
import { Icons } from "../../../../Common/AllsvgIcons";
import IbssDrawer from "../../../../Components/Drawer/IbssDrawer";

type SearchCriteriaValue = {
  src: string,
  value: string
}

// user submitted search criteria from the SearchCriteria form.
type UserSearchCriteria = {
  selectedBuildingOption: string | number, // mistyped in Class State as string | number[]? observed a number in React Components.
  selectedWorkspaceTypes: string,
  selectedSpaceTypes: string;
  selectedFloor: string | number;
  selectedZone: string,
  is_as_soon_as_possible: boolean,
  fmsfc_start_date_for_filter_modal: string | Date, // todo: this should be either a date or a string, not both
  End_Date_For_filter_modal: string | Date, // todo: this should be either a date or a string, not both
  isZoneDisabled: boolean;
}

type SpaceCardRes = {
  Node_Id: number,
  Node_Level_Name: string,
  Period_Change_Capacity_Value: number,
  Period_Change_Max_Occ_Value: number,
  Period_Change_Space_Value: number,
  Period_Current_Capacity_Value: number,
  Period_Current_Max_Occ_Value: number,
  Period_Current_Space_Value: number,
  Period_Current_Peak_Value: number,
  Space_Class: string,
  Space_Id: string,
  Space_Name: string,
  Space_Type: string,
  Space_Type_Label: string
}

class ViewSpaceAnalyticsOverview extends IbssPage<IProps, IState, QueryParams>
{
  private apiCache = appContext().apiCache;
  private labels = appContext().labels;
  private appState = appContext().state;
  private session = appContext().sessionStorageProvider;
  private history: History.History;
  private spaces = new Array<Space>();
  private get localStorageProvider() { return appContext().localStorageProvider; }
  private startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  private defaultMonthStartDate = DateTime.fromJSDate(this.startDate).toJSDate();
  private string = new StringHelper();
  private pageCacheKey = 'e639a8f4-5d3c-4e8a-9b2d-7c6f1e2d9c3a';

  constructor(props: IProps) {
    super(props, new QueryParams());
    this.history = props.history;
    this.state = {
      isLoading: false,
      spaceCards: [],
      openDrawer: false,
      searchData: ["building", "periodType", "date"],
      cardSequence: ["Work", "Support", "Amenity"],
      searchCriteria: [],
      zone: "",
      userSearchCriteria: {
        selectedBuildingOption: "",
        selectedWorkspaceTypes: "",
        selectedSpaceTypes: "",
        selectedFloor: "",
        selectedZone: "",
        is_as_soon_as_possible: false,
        fmsfc_start_date_for_filter_modal: "",
        End_Date_For_filter_modal: "",
        isZoneDisabled: false,
      },
      spaceCardResponse: [],
      selectedBuildingId: this.appState.buildingId,
      buildingName: "",
      periodStartDate: DateHelper.null(),
      periodType: 0
    };
  }

  private clearCache(): void
  {
    appContext().inMemoryCache.clear(i => i.startsWith(this.pageCacheKey + '_'));
  }

  public componentDidMount(): void
  {
    this.pageTitle = this.labels.HubMenuSpaceAnalyticsmain;
  }

  public async queryParamsDidUpdate(firstLoad: boolean, prevParams: QueryParams): Promise<void>
  {
    const queryParams = this.queryParams;
    if (firstLoad)
    {
      this.clearCache();
    }

    if (!queryParams.period)
    {
      return this.pushQueryParams({ period: this.labels.HublabelMonth }, true);
    }
    else if (!queryParams.date)
    {
      const defaultMonthStartDate = DateHelper.now(queryParams.building).minus({ months: 1 }).startOf('month');
      return this.pushQueryParams({ date: defaultMonthStartDate }, true);
    }

    const rootNode = this.localStorageProvider.getNodeData();
    const buildings = rootNode.Regions.flatMap(i => i.Buildings);
    const defaultBuilding = buildings.find(i => i.Node_Id == queryParams.building) ?? rootNode;
    const buildingName = getBuildingNameUsingBuildingId(defaultBuilding);


    const period = periodType.find(i => i.Name == queryParams.period)?.Value ?? 1;

    await this.setStateAsync({
      selectedBuildingId: queryParams.building ?? 1,
      buildingName: buildingName,
      periodStartDate: queryParams.date,
      periodType: period,
    });

    await this.fetchData()
  }

  public async fetchData(): Promise<void>
  {
    const initEndDate = this.state.periodStartDate.plusPeriods(this.state.periodType);

    const filter = {
      startDate: this.state.periodStartDate,
      endDate: initEndDate,
      spaceId: "",
      periodType: this.state.periodType
    };

    this.session.setSpaceAnalyticsCriteria(filter);
    const endpoint = {
      name: 'spaceAnalytics.getOverviewWorkSpaceClassification',
      buildingId: this.state.selectedBuildingId,
      viewType: "Total",
      periodType: this.state.periodType,
      startDate: this.state.periodStartDate.toUtcByNode(this.state.selectedBuildingId),
      endDate: initEndDate.toUtcByNode(this.state.selectedBuildingId),
      groupBy: "Building"
    };
    try
    {
      this.setState({ isLoading: true });
      const response = await appContext().inMemoryCache.lazyGetWithQuickExpiry(
        `${this.pageCacheKey}_${JSON.stringify(endpoint)}`,
        () => apis.getOverviewWorkSpaceClassification(
          endpoint.buildingId,
          endpoint.viewType,
          endpoint.periodType,
          endpoint.startDate,
          endpoint.endDate,
          endpoint.groupBy
        )
      );

        this.setState({ spaceCardResponse: this.cardSequenceOutput(response), isLoading: false });
        this.updateSearchResults(this.state.searchCriteria);

    }
    catch (error)
    {
        this.setState({ isLoading: false });
    }

    this.setState({ searchCriteria: this.makeSearchCriteria() });
  }

  // Sequence of data card
  public cardSequenceOutput(res: SpaceCardRes[]) {
    const array2 = ["Work", "Support", "Amenity"];

    const sortedArray = res.sort((a: { Space_Class: string }, b: { Space_Class: string }) => {
      const aIndex = array2.indexOf(a.Space_Class);
      const bIndex = array2.indexOf(b.Space_Class);
      return aIndex - bIndex;
    });
    return sortedArray
  }

  // Breadcrumb call
  public makeSearchCriteria(): SearchCriteriaValue[] {
    let arr: any = [];
    this.state.searchData.map((option: string) => {
      if (option === "building") {
        if (this.state.selectedBuildingId != null) 
        {
          arr.push({
            src: Icons.building,
            value: getBuildingNameUsingBuildingId(this.state.selectedBuildingId),
          });
        }
      }
      if (option === "periodType")
      {
        const periodName = periodType.find(i => i.Value === this.state.periodType)?.Name ?? 'Month';

          arr.push({
            src: Icons.calenderIcon,
            value: periodName
          });

      }
      if (option === "date") {
        if (this.state.periodStartDate != null ) 
        {
          const startDate = this.state.periodStartDate.toFormat('dd/MM/yy');
          arr.push({
            src: Icons.calenderIcon,
            value: startDate,
          });
        }
      }
    });
    return arr;
  }

  // Update data for changed criteria for form

  public async handleGetSearchData(query: IQuery)
  {

    const period = periodType.find(i => i.Value === query.periodType)?.Name ?? this.labels.HublabelMonth;
    const date = query.periodStartDate;
    this.pushQueryParams({
      period: period,
      date: date
    })
  }

  public async updateSearchResults(
    searchCriteria: SearchCriteriaValue[]
  ): Promise<void> {

    this.setState({
      isLoading: false,
      searchCriteria: searchCriteria,
    });
  }

  public toggleFilterCriteraDrawer(isOpen: boolean): void 
  {
    this.setState({
      openDrawer: isOpen,
    });
  }

  public editSearchCriteria() {
    this.setState({
      openDrawer: true,
    });
  }

  public render(): JSX.Element {
    return (
      <>
        <link
          rel="stylesheet"
          href="/src/pages/Flex/Search/SearchComponent.css"
        ></link>
        <div key="/Pages/Flex/Search">
          {this.state.isLoading && <Spinner />}
          <div className="page-height-exct-header">
            <div
              className="rightPanel-main-content"
              style={{ paddingBottom: "10px" }}
            >
              <div className="space-box-cont">
                <div className="left-space-box-cont flex-row-bredcrumb">

                  {/* Breadcrumb Component */}
                  <IbssbreadcrumbLeft value={this.state.searchCriteria} />
                </div>
                <div className="right-space-box-cont">
                  {!this.state.openDrawer ? (
                    <IbssButtonRedo sx={{whiteSpace:"nowrap"}}
                      variant='contained'
                      onClick={() => this.toggleFilterCriteraDrawer(true)}
                    >
                      {this.labels.HubButtonEditsearchcriteria}
                    </IbssButtonRedo>
                  ) : (
                    ""
                  )}
                </div>
                {/* Toggle window */}

                <IbssDrawer 
                    open={this.state.openDrawer} 
                    onClose={() => this.toggleFilterCriteraDrawer(false)} 
                    anchor='right' 
                    className='flex-search-filter-criteria' 
                    style={{ backgroundColor: "var(--ui-background-alternate)" }}
                >

                    <SpaceAnalyticsMainSearch 
                      toggleDrawer={(isOpen: boolean) => this.toggleFilterCriteraDrawer(isOpen)}
                      buildingId={this.state.selectedBuildingId}
                      periodType={this.state.periodType}
                      periodStartDate={this.state.periodStartDate}
                      periodEndDate={this.state.periodStartDate.plusPeriods(this.state.periodType)} 
                      updateSearchResults={(query: IQuery) => this.handleGetSearchData(query)}
                      
                      />
                  </IbssDrawer>
              </div>

              <div className="space-box-cont">
                <div className="left-space-box-cont flex-row-bredcrumb">
                <IbssPageHeader
                    title={this.labels.HubLabelSearchResults}
                />
                </div>
              </div>
              <Box className={""} height={"100%"}>
              {/* No result found */}
              {this.state.spaceCardResponse.length === 0 ? (
                <Alert
                  key="noResults"
                  title={"There are currently no spaces available"}
                  text={`Based on your search criteria we've found no spaces available, please adjust your criteria and try again.`}
                />
              ) : null}
              <Grid container spacing={1.5}>
              {this.state.spaceCardResponse?.map((props, index) => (
                    <SpaceAnalyticsCard
                      key={index}
                      spaceClass={props.Space_Class}
                      periodCurrentPeakValue={props.Period_Current_Peak_Value}
                      periodCurrentCapacityValue={props.Period_Current_Capacity_Value}
                      periodCurrentSpaceValue={props.Period_Current_Space_Value}
                      periodType={this.state.periodType}
                      startDate={this.state.periodStartDate.toISO()}
                      endDate={this.state.periodStartDate.plusPeriods(this.state.periodType).toISO()}
                      buildingNodeId={props.Node_Id}
                      buildingName={props.Node_Level_Name}
                    />
                  ))}
              </Grid>
            </Box>
            </div>
          </div>
        </div>
      </>
    );
  }
}


const mapStateToProps = (state: any) => {
  return {
    lightModeTheme: state.lightModeTheme,
    mainPageTitle: state.mainPageTitle,
    flexMySearchFilterCriteria: state.flexMySearchFilterCriteria,
    onelensSpaceAnalyticsOverview: state.onelensSpaceAnalyticsOverview
  };
};

export default ViewSpaceAnalyticsOverview;

interface IProps extends RouterProps
{
}

interface IState
{
  spaceCardResponse: Array<SpaceCardRes>
  isLoading: boolean,
  spaceCards: Array<SpaceCardProps>,
  openDrawer: boolean,
  searchData: Array<string>,
  cardSequence: Array<string>,
  searchCriteria: Array<SearchCriteriaValue>,
  zone: string,
  userSearchCriteria: UserSearchCriteria,
  selectedBuildingId: number,
  buildingName: string,
  periodStartDate: DateTime,
  periodType: number

}
export interface IQuery
{
    buildingId: number | string;
    periodStartDate: DateTime;
    periodEndDate: DateTime;
    periodType: number;
    buildingName: string;
}